import { paymentSuccessHandler } from '../../components/PaymentMethodSelector/utils';
import SelectorEngine from '../../utils/dom/selector-engine';

class IminPaymentProcessing {
	constructor() {
		this._wrappers = SelectorEngine.findOne('.js-imin-payment-processing');
		this.init();
	}

	init() {
		if (this._wrappers) {
			const paymentidentifier = sessionStorage.getItem('paymentidentifier');
			const source = sessionStorage.getItem('source');
			const numberOfPlayers = sessionStorage.getItem('IminplayerCount');
			const payload = { source, numberOfPlayers };
			let playerDetails = sessionStorage.getItem('iminPlayerDetails');
			if (playerDetails) {
				payload.playerDetails = JSON.parse(playerDetails);
			}
			paymentSuccessHandler({
				// eslint-disable-next-line unicorn/no-null
				id: paymentidentifier,
				extraParam: payload,
				provider: source
			});
		}
	}
}

const PaymentProcessing = new IminPaymentProcessing();
export default PaymentProcessing;
